<template>
  <el-tooltip placement="top" :content="getContent" :disabled="showTooltip">
    <el-select :placeholder="placeholder" ref="select" :filterable="icFilterable" :multiple="icMultiple" :clearable="icClearable" v-model="icVal" @input="change($event)" :disabled="disableEditor">
      <el-option :label="$t('common.all')" value="" v-if="allValues"></el-option>
      <el-option v-for="item in inputChoices" :key="item.code" :label="item.value" :value="item.code"></el-option>
    </el-select>
  </el-tooltip>
</template>

<script>
import commonFun from "@/utils/commonFun";

export default {
  props: ['value', 'table', 'field', 'tableFields', 'filterable', 'isShowTooltip', 'clearable', 'disabled', 'options', 'multiple', 'excludes', 'placeholder', 'allValues'],
  name: "icSelect",
  data() {
    return {
      icVal: this.value == null ? null : ((typeof this.value == 'object') ? this.value.map(value => value + "") : (this.value == null ? null : this.value + "")),
      icFilterable: this.filterable == undefined ? false : true,
      icClearable: this.clearable == undefined ? false : true,
      icMultiple: this.multiple == undefined ? false : true,
      disableEditor: this.disabled == undefined ? false : this.disabled,
      showTooltip: this.isShowTooltip == undefined ? true : false
    }
  },
  computed: {
    changeDisabled() {
      return this.disabled == undefined ? false : this.disabled
    },
    getContent() {
      if (this.isShowTooltip) {
        let contentStr = ""
        let ics = null;
        ics = commonFun.listIC('TT_QSPI_QIP', 'CAUSE_OF_NONCONFORMITY');
        for (let key in ics) {
          if (key == this.icVal) {
            contentStr = ics[key].value
          }
        }
        return contentStr
      }
    },
    inputChoices() {
      if (this.options) {
        let keys = Object.keys(this.options);
        let ics = {};
        if (Array.isArray(this.options)) {
          ics = this.options;
        } else {
          keys.forEach(key => {
            ics[key] = { code: key, value: this.options[key] };
          });
        }
        return this.sortBySeq(ics);
      } else {
        let table = this.table;
        let field = this.field;
        if (this.tableFields) {
          let ics = {};
          this.tableFields.forEach(tableField => {
            let tmpIcs = commonFun.listIC(tableField.table, tableField.field);
            if (commonFun.isNotEmpty(tmpIcs)) {
              for (let key in tmpIcs) {
                ics[key] = tmpIcs[key];
              }
            }
          });
          return this.sortBySeq(ics);
        } else {
          let ics = null;
          ics = commonFun.listIC(table, field);
          if (commonFun.isNotEmpty(ics)) {
            if (commonFun.isNotEmpty(this.excludes)) {
              commonFun.convertToArray(this.excludes).forEach(exclude => {
                delete ics[exclude];
              });
            }
          }
          return this.sortBySeq(ics);
        }
      }
    }
  },
  methods: {
    sortBySeq: function (arr) {
      if (commonFun.isNotEmpty(arr)) {
        let icList = [];
        for (let key in arr) {
          icList.push(arr[key])
        }
        icList.sort((a, b) => {
          let aSeq = -9999999, bSeq = -9999999;
          if (commonFun.isNotEmpty(a.seq)) { aSeq = a.seq; }
          if (commonFun.isNotEmpty(b.seq)) { bSeq = b.seq; }
          return aSeq - bSeq;
        });
        return icList;
      }
      return arr;
    },
    change: function (val) {
      this.$emit('input', val);
      this.$emit('change', val);
      if (commonFun.isEmpty(val)) {
        this.$emit('check', checkedData);
        return;
      }
      let checkedData = null;
      if (this.icMultiple) {
        let inputChoices = this.inputChoices;
        checkedData = val.map(value => {
          let ic = {
            code: value,
            value: inputChoices.filter(item => item.code == val)[0].value
          }
          return ic;
        });
      } else {
        let inputChoices = this.inputChoices;
        console.log(inputChoices, val, inputChoices.filter(item => item.code == val)[0]);
        checkedData = {
          code: val,
          value: inputChoices.filter(item => item.code == val)[0].value
        };
      }
      this.$emit('check', checkedData);
    }
  },
  watch: {
    value(newVal) {
      this.icVal = newVal == null ? null : ((typeof newVal == 'object') ? newVal.map(value => value + "") : (newVal == null ? null : newVal + ""));
    },
    filterable(newVal) {
      this.icFilterable = newVal == undefined ? false : true;
    },
    clearable(newVal) {
      this.icClearable = newVal == undefined ? false : true;
    },
    multiple(newVal) {
      this.icMultiple = newVal == undefined ? false : true;
    },
    disabled(newVal) {
      this.disableEditor = newVal == undefined ? false : newVal;
    },
  }
}
</script>

<style >
</style>
